module.exports = __webpack_public_path__ + "img/blocked.b96eb71c.svg";